module.exports = __webpack_public_path__ + "img/01010401.429debb7.png";